/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
  var $bannerImage = $('.hotspot-banner__image');
  var rafPending   = false;
  var MOBILE_BREAKPOINT = 799;

  function updateImageWidth() {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      $bannerImage.css({ width: '' });
      rafPending = false;
      return;
    }
    var rect     = $bannerImage[0].getBoundingClientRect();
    var progress = 1 - Math.max(0, Math.min(1, rect.top / window.innerHeight));
    $bannerImage.css({ width: (88 + progress * 12) + '%' });
    rafPending = false;
  }

  if ($bannerImage.length) {
    $(window).on('scroll.hotspotExpand resize.hotspotExpand', function () {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(updateImageWidth);
      }
    });
    updateImageWidth();
  }

  function closeAllTooltips() {
    var $active = $('.hotspot-banner__tooltip.active');
    if (!$active.length) return;
    $active.removeClass('active');
    $active.find('.hotspot-banner__popup').stop(true).fadeOut(200);
  }

  function positionPopup($tooltip) {
    var $popup     = $tooltip.find('.hotspot-banner__popup');
    var $container = $tooltip.closest('.hotspot-banner__image');

    $popup.css({ visibility: 'hidden', display: 'block' });
    var popupWidth  = $popup[0].offsetWidth;
    var popupHeight = $popup[0].offsetHeight;
    $popup.css({ visibility: '', display: '' });

    var tr = $tooltip[0].getBoundingClientRect();
    var cr = $container[0].getBoundingClientRect();

    if (window.innerWidth <= 799) {
      var desiredLeft = cr.left + (cr.width - popupWidth) / 2;
      desiredLeft = Math.max(cr.left + 8, Math.min(desiredLeft, cr.right - popupWidth - 8));
      var goUpMob = cr.bottom - tr.bottom < popupHeight + 20;

      $popup.css({
        left: (desiredLeft - tr.left) + 'px',
        right: 'auto',
        top: goUpMob ? 'auto' : 'calc(100% + 8px)',
        bottom: goUpMob ? 'calc(100% + 8px)' : 'auto',
        transform: 'none'
      });
      return;
    }

    var goLeft = cr.right  - tr.right  < popupWidth;
    var goUp   = cr.bottom - tr.bottom < popupHeight;

    if      (goLeft && goUp) $popup.css({ top: '0',    left: '0',  bottom: 'auto', right: 'auto', transform: 'translate(-100%, -100%)' });
    else if (goLeft)         $popup.css({ bottom: '0', left: '0',  top: 'auto',    right: 'auto', transform: 'translate(-100%, 100%)'  });
    else if (goUp)           $popup.css({ top: '0',    right: '0', bottom: 'auto', left: 'auto',  transform: 'translate(100%, -100%)'  });
    else                     $popup.css({ bottom: '0', right: '0', top: 'auto',    left: 'auto',  transform: 'translate(100%, 100%)'   });
  }

  $(document).on('click', '.hotspot-banner__tooltip', function (e) {
    e.stopPropagation();
    var $tooltip = $(this);
    var isActive = $tooltip.hasClass('active');
    closeAllTooltips();
    if (!isActive) {
      $tooltip.addClass('active');
      positionPopup($tooltip);
      $tooltip.find('.hotspot-banner__popup').stop(true).hide().fadeIn(300);
    }
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.hotspot-banner__tooltip').length) {
      closeAllTooltips();
    }
  });

  if (typeof ScrollReveal !== 'undefined' && window.innerWidth > 801) {
    var sr = ScrollReveal();

    $('.hotspot-banner').each(function () {

      sr.reveal('.hotspot-banner__title', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });

      sr.reveal('.hotspot-banner__text', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    });
  }
});